import React, {FC} from 'react';
import {IProduct, IProductOption} from '../../../../../../types/galleryTypes';
import {useGlobals, withGlobals} from '../../../../../../globalPropsContext';
import {ProductQuickAddBoxSelection} from './ProductQuickAddBoxSelection/ProductQuickAddBoxSelection';
import {ProductQuickAddDropdown} from './ProductQuickAddDropdown/ProductQuickAddDropdown';
import {TextualOptionType} from '../../../../../../constants';

export interface IProductQuickAddTextualOptionProps {
  productId: IProduct['id'];
  option: IProductOption;
}

const ProductQuickAddTextualOptionComp: FC<IProductQuickAddTextualOptionProps> = ({productId, option}) => {
  const {styles, stylesParams} = useGlobals();
  const isButtonsType = styles.get(stylesParams.gallery_textualOptionType) === TextualOptionType.BUTTONS;

  return isButtonsType ? (
    <ProductQuickAddBoxSelection productId={productId} option={option} />
  ) : (
    <ProductQuickAddDropdown productId={productId} option={option} />
  );
};

export const ProductQuickAddTextualOption = withGlobals(ProductQuickAddTextualOptionComp);
